'use strict';
/* ==========================================================================
   levels/map.js — the hub: THE CIVIC PRESS's front page (DESIGN.md §1–§2), structure copied from lessons/ratify's
   docket and lessons/circles' to-do list. Left: Rex (he runs the press) + a speech bubble. Right: the page, one headline
   block per lesson.json step in a 2 × 2 grid (a new step shows up by itself): a wax-seal story number, the title in
   wood type, the tag in typewriter, a woodcut mark. A finished step gets a CERTIFIED stamp (lesson.json
   completeCard.title), or its score when Game.progress.scores[id] = {best, of}; the first step not done yet gets a red
   ink "next!" arrow. All four done: the certificate's wax seal at the foot of the page. A block →
   Game.replace(new Levels[id]()). On a phone held upright the steps are rows in the portrait dock (Dock.map) and the
   page is only the picture (no hit areas, no bubble).
   ========================================================================== */
(function () {
  const CV = () => window.Civic;
  const PAGE = { x: 1190, y: 556, w: 1340, h: 1000 };
  const BW = 600, BH = 300;
  // Rex's line on the map (captions only; not voiced)
  const SAY = {
    hello: 'Front page is blank. Four stories to file. Start with story one.',
    next: 'Story filed. Next one before the presses roll.',
    done: 'All four certified. Stop the presses.',
  };
  const MARKS = ['seat', 'map', 'gavel', 'song'];   // 'gavel': a calendar page (January 6: College.timeline(2028).count)

  /* the blocks, laid out from lesson.json steps (numbers count the steps that earn a stamp, like the home page) */
  function tags() {
    const S = (Game.lesson && Game.lesson.steps) || [];
    let k = 0;
    return S.map((s, i) => {
      const stamps = s.stamp !== false; if (stamps) k++;
      const col = i % 2, row = Math.floor(i / 2);
      return { id: s.id, n: stamps ? k : null, title: s.title, sub: s.tag || '', i,
        x: PAGE.x - 312 + col * 624, y: 382 + row * 352, rot: [-0.006, 0.005, 0.004, -0.005][i % 4] };
    });
  }
  const nextStep = () => tags().find(tg => tg.n != null && !Game.progress.stamps[tg.id]);

  function drawBlock(tg, hover, t0, stamped) {
    const Cv = CV(), s = pop(T, t0 + 0.35 + tg.i * 0.12, 0.4, 2.2);
    if (s <= 0) return;
    g.save();
    g.translate(tg.x, tg.y + (hover ? -6 : 0)); g.rotate(tg.rot); g.scale(s * (hover ? 1.02 : 1), s * (hover ? 1.02 : 1));
    paperRect(0, 0, BW, BH, hover ? '#fffaf0' : '#f6efdc', { seed: 40 + tg.i, depth: hover ? 1.6 : 0.9, boil: false });
    g.fillStyle = '#2b2420'; g.fillRect(-BW / 2 + 22, -BH / 2 + 70, BW - 44, 3);
    Cv.seal(-BW / 2 + 60, -BH / 2 + 40, 30, { text: tg.n == null ? '' : String(tg.n), seed: 50 + tg.i * 3, ribbon: false });
    g.font = "24px 'Special Elite', monospace"; g.textAlign = 'left'; g.textBaseline = 'middle'; g.fillStyle = '#9e2b25';
    g.fillText(tg.n == null ? 'EXTRA' : `STORY ${tg.n}`, -BW / 2 + 104, -BH / 2 + 40);
    // the headline: wood type, two lines at most, shrunk to the column
    const words = String(tg.title).toUpperCase(), lines = MapKit._wrap(words, BW - 60, "54px 'Alfa Slab One'").slice(0, 2);
    lines.forEach((l, j) => MapKit._fitText(l, -BW / 2 + 30, -BH / 2 + 118 + j * 60, 54, BW - 200, { font: "'Alfa Slab One', serif", align: 'left', color: '#2b2420' }));
    MapKit._fitText(tg.sub, -BW / 2 + 30, BH / 2 - 44, Math.min(30, UI.text(28)), BW - 70, { font: "'Special Elite', monospace", align: 'left', color: '#3a3127' });
    // a woodcut mark on the right
    const mk = stamped ? null : MARKS[tg.i % MARKS.length];   // a stamped story: the stamp takes the mark's place
    if (mk === 'seat') MapKit.card('seat', BW / 2 - 90, -6, { s: 1.4 });
    else if (mk === 'map') { MapKit.mark('lantern', BW / 2 - 118, -4, 70); MapKit.mark('anchor', BW / 2 - 56, -4, 70); }
    else if (mk === 'gavel') { const d = College.timeline(2028).count; MapKit.card('calendar', BW / 2 - 84, 4, { s: 0.62, rot: 0.06, month: d.monthName.slice(0, 3), day: d.day }); }
    else if (mk === 'song') MapKit.card('seal', BW / 2 - 90, -10, { s: 0.8, text: '270' });
    g.restore();
  }

  class MapScene extends Scene {
    enter() {
      const st = Game.progress.stamps, T_ = tags().filter(tg => tg.n != null);
      this.allDone = T_.every(tg => st[tg.id]);
      this.say = this.allDone ? SAY.done : T_.some(tg => st[tg.id]) ? SAY.next : SAY.hello;
      this.stampNew = Game._justStamped; Game._justStamped = null;
      Audio.play('paper', { gain: 0.5 });
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
      MapKit.load();
    }
    open(id) {
      Audio.play('pop', { gain: 0.6 });
      const C = Levels[id];
      if (typeof C === 'function') Game.replace(new C());
      else UI.toast('coming soon');
    }
    keyDown(k) {
      const all = tags(), n = parseInt(k, 10);
      if (n >= 1 && n <= all.length) this.open(all[n - 1].id);
      if (k === 'Enter') this.open((nextStep() || all[0]).id);
    }

    draw() {
      UI.allLessons();                       // "← All lessons": back to the site's home page (core/ui.js)
      const t0 = this.enteredAt, t = this.t, docked = UI.docked(), Cv = CV();
      g.fillStyle = paperTile(MapKit.INK.kraft, 3, 'tex_kraft'); g.fillRect(0, 0, Game.W, Game.H);
      // the front page
      paperRect(PAGE.x, PAGE.y, PAGE.w, PAGE.h, '#f3ecd9', { seed: 83, rot: 0.003, depth: 1.8, boil: false });
      if (IMG.tex_news) texScrap('tex_news', PAGE.x, PAGE.y + 60, PAGE.w - 120, PAGE.h - 260, { seed: 84, depth: 0, alpha: 0.1, torn: false });
      tape(PAGE.x - 560, 70, 170, -0.5, undefined, 5); tape(PAGE.x + 560, 70, 170, 0.5, undefined, 6);
      Cv.masthead('THE CIVIC PRESS', PAGE.x, 128, PAGE.w - 120, { size: 74, date: (Game.lesson && Game.lesson.title) || '', price: 'Four stories to certify', t0: t0 + 0.1, color: '#2b2420' });

      // Rex + speech (the speech goes into the dock when docked)
      const rise = E.outBack(P(T, t0 + 0.2, t0 + 0.7), 1.4);
      Puppet.draw('rex', 270, 1080 + (1 - rise) * 500, 680, { facing: 1, t: T, env: t > 0.6 && t < 3 ? 0.25 + 0.25 * Math.sin(T * 17) : 0 });
      if (docked) Dock.map({ title: 'The Civic Press', say: this.say, who: (LessonHooks.speakers && LessonHooks.speakers.rex || {}).name, open: id => this.open(id) });
      else if (t > 0.6) UI.speech(this.say, 300, 236, { side: 'left', w: 470, t0: t0 + 0.6 });

      const nx = nextStep();
      tags().forEach(tg => {
        const hit = docked ? { hover: false, clicked: false } : UI._hit('tag' + tg.i, tg.x, tg.y, BW, Math.max(BH, UI.tap(BH)));
        if (hit.hover && !this['hov' + tg.i]) Audio.play('paper', { gain: 0.2, rate: 1.3 });
        this['hov' + tg.i] = hit.hover;
        drawBlock(tg, hit.hover, t0, !!Game.progress.stamps[tg.id]);
        if (Game.progress.stamps[tg.id]) {
          let s = 1;
          if (this.stampNew === tg.id) {
            const at = t0 + 0.9;
            s = pop(T, at, 0.18, 1.2) * (1 + 1.4 * (1 - P(T, at, at + 0.12)));
            if (T >= at && !this.stampPlayed) { this.stampPlayed = true; Audio.play('stamp'); }
          } else s = pop(T, t0 + 0.8, 0.25, 1.5);
          const sc = Game.progress.scores && Game.progress.scores[tg.id];
          const label = (Game.lesson.completeCard && Game.lesson.completeCard.title) || 'CERTIFIED';
          UI.stamp(sc && sc.best != null && sc.of ? `${sc.best}/${sc.of}` : label, tg.x + BW / 2 - 140, tg.y + 10, { rot: -0.14, s: s * 0.5, color: '#9e2b25' });
        }
        if (!this.allDone && !docked && nx && nx.id === tg.id) {   // docked: the dock row says next!
          const ns = pop(T, t0 + 1.4, 0.4), bob = Math.sin(T * 4) * 8;
          if (ns > 0) {
            g.save(); g.globalAlpha = ns;
            const ax = tg.x - BW / 2 - 6 - bob, ay = tg.y + 40;
            inkArrow(ax - 80, ay + 60, ax, ay, { w: 6, color: '#9e2b25', seed: 600 + tg.i, bulge: -20 });
            hand('next!', ax - 110, ay + 96, 42, 0, { dur: 0.01, color: '#9e2b25', rot: -0.1, seed: 610 + tg.i });
            g.restore();
          }
        }
        if (hit.clicked) this.open(tg.id);
      });
      // all four certified: the certificate's seal at the foot of the page
      if (this.allDone) {
        const s = pop(T, t0 + 1.2, 0.3, 2);
        if (s > 0) {
          MapKit.card('seal', PAGE.x, 980, { s: 1.1 * s, text: '270' });
          UI.stamp((Game.lesson.completeCard && Game.lesson.completeCard.title) || 'CERTIFIED', PAGE.x + 330, 990, { rot: -0.08, s: 0.62 * s, color: '#9e2b25' });
        }
      }
    }
  }
  MapScene.tags = () => tags().map(tg => ({ id: tg.id, x: tg.x, y: tg.y }));   // tools/integration.js clicks these

  Levels.map = MapScene;
})();
